module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('v-header'), _vm._v(" "), _c('div', {
    staticClass: "list-content"
  }, [(_vm.path == 'knowledge') ? _c('v-knowledge') : _vm._e(), _vm._v(" "), (_vm.path == 'activity') ? _c('Activity') : _vm._e(), _vm._v(" "), (_vm.path == 'recruitinner') ? _c('RecruitInner') : _vm._e(), _vm._v(" "), (_vm.path == 'recruitouter') ? _c('RecruitOuter') : _vm._e(), _vm._v(" "), (_vm.path == 'industry') ? _c('Industry') : _vm._e()], 1), _vm._v(" "), _c('v-backTop')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4e8b177f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/list/App.vue
// module id = 299
// module chunks = 8